import React, { useState } from 'react';
import AlphabetCell from '../AlphabetCell';
import VigenereTable from './VigenereTable'

const VigenereCipherEncryption = ({ table, selectedRow, selectedColumn, cipherText }) => {

    return (
        <div style={{width: "1000px"}}>
            <p style={{ textAlign: 'left', fontSize: '20px', fontWeight: 'bold', margin: '40px 0 10px 0' }}>Encryption</p>
            <p style={{ textAlign: 'center', fontSize: '15px', fontWeight: 'bold', margin: '30px 20px 0 0' }}>Plaintext</p>
            <div style={{ textAlign: 'left', display: 'flex' }}>
                <div style={{ display: 'inline' }}>
                    <div className='wrapper' style={{alignItems:"center"}}>
                        <p style={{ textAlign: "right", fontSize: '15px', fontWeight: 'bold', margin:'0 30px 0 0'}}>Key</p>
                        <VigenereTable table={table} selectedRow={selectedRow} selectedColumn={selectedColumn} />
                    </div>
                </div>
            </div>
            <p style={{ fontSize: 19 }} ><span style={{ fontWeight: "bold" }}>Cipher Text :</span>{cipherText}</p>
        </div>
    );
};

export default VigenereCipherEncryption;
